<template>
  <div class="h-auto ml-0 p-3 w-full lg:mr-3">
    <!-- <div class="bg-white mx-3 mt-3 rounded-t-md border-b-0.5">
      <div class="flex justify-between items-center p-3">
        <p class="font-semibold lg:text-base text-sm">
          Company Time Off
        </p>
      </div>
    </div> -->

    <el-tabs type="border-card">
      <el-tab-pane
        v-for="(tab, index) in subMenus"
        :key="index"
        :label="tab.name"
        @click="(e) => setTab(e, tab.name)"
      >
        <LeaveTypeList v-if="index == 0"></LeaveTypeList>
        <LeaveWorkflow v-if="index == 1"></LeaveWorkflow>
        <LeavePeriods v-if="index == 2"></LeavePeriods>
        <TimeOffJournalsList v-if="index == 3"></TimeOffJournalsList>
        <TimeOffLedgerList v-if="index == 4"></TimeOffLedgerList>
        <TimeOffBaseCalendar v-if="index == 5"></TimeOffBaseCalendar>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import LeaveTypeList from "@/components/CompanySetups/leaveTypes/leaveTypeList.vue";
import LeaveWorkflow from "@/components/CompanySetups/leaveWorkflow/LeaveWorkflow.vue";
import LeavePeriods from "@/components/CompanySetups/leavePeriods/leavePeriodsList.vue";
import TimeOffJournalsList from "@/components/CompanySetups/timeOffSetups/timeOffJournalsList.vue";
import TimeOffLedgerList from "@/components/CompanySetups/timeOffSetups/timeOffLedgerEntriesList.vue";
import TimeOffBaseCalendar from "@/components/CompanySetups/timeOffSetups/timeOffBaseCalendar.vue";

export default {
  name: "CompanyTimeOffSetups",
  components: {
    LeaveTypeList,
    LeaveWorkflow,
    LeavePeriods,
    TimeOffJournalsList,
    TimeOffLedgerList,
    TimeOffBaseCalendar,
  },
  data() {
    return {
      tTKey: 0,
      tWKey: 1,
      tPKey: 2,
      tJKey: 3,
      tLKey: 4,
      bCKey: 5,

      selectedSubMenu: "Time off Types",
      subMenus: [
        {
          name: "Time off Types",
          route: "timeoff-types",
        },
        { name: "Time off Workflows", route: "time-off-workflows" },
        {
          name: "Time off Periods",
          route: "timeoff-periods",
        },
        { name: "Time off Journals", route: "time-off-journals" },
        { name: "Time off Ledgers", route: "time-off-ledgers" },
        { name: "Base Calendar", route: "base-calendar" },
      ],
    };
  },
  created() {
    console.log(window)
  },
  mounted() {

  },
  watch: {
    $route(to) {
      this.subMenus.forEach((menu) => {
        if (menu.route == to.params.type) {
          this.selectedSubMenu = menu.name;
        }
      });
      switch (this.selectedSubMenu) {
        case "Time off Types":
          this.tTKey++;
          break;
        case "Time off Workflows":
          this.tWKey++;
          break;
        case "Time off Periods":
          this.tPKey++;
          break;
        case "Time off Journals":
          this.tJKey++;
          break;
        case "Time off Ledgers":
          this.tLKey++;
          break;
        case "Base Calendar":
          this.bCKey++;
          break;
      }
    },
  },
};
</script>
